@if (question) {
  <div>
    @if (!displayAgreement(question.section_name)) {
      <label for="">{{ question.question_text }}</label>
    } @else {
      <div class="agreement" [innerHtml]="question.question_text"></div>
    }

    <mat-radio-group class="single-choice" [value]="selected" (change)="save($event)" data-testid="single-choice-radio-group">
      @for (answer_order of question.answer_order; track answer_order) {
        <mat-radio-button [value]="answer_order.answer_id" [attr.data-testid]="'single-choice-radio-button-' + answer_order.answer_id">
          {{ answer_order.answer_text }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
}
